<template>
  <div class="content">
    <div class="real">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {}
  },
})
</script>

<style lang="scss" scoped>
.content {
  .real {
    padding-top: 30px;
    width: 1024px;
    // border: 1px solid red;
    margin: 0 auto;

    @media screen and (max-width: 1450px) {
      width: 1024px;
    }
    @media screen and (max-width: 992px) {
      width: 960px;
    }
    @media screen and (max-width: 768px) {
      width: 750px;
    }
  }
}
</style>